var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('star-rating',{attrs:{"config":_vm.config}}),_vm._v(" "),_c('span',{staticClass:"num-rate"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }